import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthenticationService } from '../authentication/authentication.service';
import { Observable } from 'rxjs';

@Injectable()
export class Landinguard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthenticationService) {
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        return this.authService.getIsAuthorized().pipe(
            map((isAuth: boolean) => {
                if (!isAuth) {
                    return true;
                }
                this.router.navigate(['/']);
                return false;
            })
        );
    }
}